import { useMemo, useState } from "react";

import { SearchBar } from "@/components/search-bar";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Guest, PublicEvent } from "@classview/shared-types";

import { ViewParticipantsTable } from "./view-participants-table";

type ViewParticipantsModalProps = {
  guests: Guest[];
  event: PublicEvent;
};

export function ViewParticipantsModal({
  guests,
  event,
}: ViewParticipantsModalProps) {
  const [search, setSearch] = useState("");

  const filteredAttendees = useMemo(() => {
    return (
      guests?.filter((guest) => {
        const name = `${guest.firstName} ${guest.lastName}`.toLowerCase();
        return name.includes(search.toLowerCase());
      }) ?? []
    );
  }, [search, guests]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="w-full">
          View All
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Attendees</DialogTitle>
          <DialogDescription>
            See other users who are attending this event.
          </DialogDescription>
        </DialogHeader>
        <DialogBody className="w-full">
          <div className="flex w-full flex-col gap-2">
            <Label>Search</Label>
            <SearchBar
              search={search}
              setSearch={(value) => setSearch(value as string)}
              placeholder="Search for a participant"
              className="min-w-full"
            />
          </div>
          {filteredAttendees?.length ? (
            <div className="mt-4">
              <ViewParticipantsTable guests={filteredAttendees} event={event} />
            </div>
          ) : null}
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
